// extracted by mini-css-extract-plugin
module.exports = {"table":"style_table__Rf5O6","rounded":"style_rounded__jW2Q4","minitables":"style_minitables__g4_oR","blur":"style_blur__anlLg"};